var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeletered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10226",
    "data-name": "Group 10226",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    "data-name": "Path 4003",
    d: "M0,0H17V17H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4004",
    "data-name": "Path 4004",
    d: "M12.625,4.833h3.542V6.25H14.75v9.208a.708.708,0,0,1-.708.708H4.125a.708.708,0,0,1-.708-.708V6.25H2V4.833H5.542V2.708A.708.708,0,0,1,6.25,2h5.667a.708.708,0,0,1,.708.708Zm.708,1.417h-8.5v8.5h8.5ZM10.085,10.5l1.252,1.252-1,1L9.083,11.5,7.831,12.754l-1-1L8.082,10.5,6.829,9.248l1-1L9.083,9.5l1.252-1.252,1,1ZM6.958,3.417V4.833h4.25V3.417Z",
    transform: "translate(-0.583 -0.583)",
    fill: "#ff8080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletered);
export default __webpack_public_path__ + "static/media/deletered.bc9d9da31ae2783fc8607cb6a2d48c83.svg";
export { ForwardRef as ReactComponent };